import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef, NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { HistoricoDireccionesDto } from '../shared/models/historico-direcciones-dto';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { CargandoComponent } from '../cargando/cargando.component';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-historico-asignaciones',
  templateUrl: './historico-asignaciones.component.html',
  styleUrls: ['./historico-asignaciones.component.css']
})
export class HistoricoAsignacionesComponent implements OnInit {

  principalForm = this.formBuilder.group({
    direccionIpControl: new FormControl('', Validators.required),
    fechaDesdeDP: new FormControl(),
    fechaHastaDP: new FormControl()
  });


  modalRef: NgbModalRef;
  direccionIp: string = "";
  fechaDesdeTemp;
  fechaHastaTemp;
  stringDesde: string;
  stringHasta: string;
  stringDesdeInicial: string = environment.fechaInicial;
  historicos: HistoricoDireccionesDto[] = new Array<HistoricoDireccionesDto>();
  indexSeleccionado:number;
  mensajeAlerta: string="";
  advertenciaPermisos: string="";
  @ViewChild('downloadLink') private downloadLink: ElementRef;

  constructor(private administradorIpService: AdministradorIpService,
  private formBuilder: FormBuilder,
  private modalService: NgbModal) { }

  ngOnInit() {
  }

  public consultarHistorico(cargandoModal): void{
    this.modalRef = this.modalService.open(cargandoModal,{backdrop: 'static', keyboard:false, size: 'lg'});
    if(this.fechaDesdeTemp != null){
        this.stringDesde = this.convertirDatePickerToString(this.fechaDesdeTemp);
    }else{
      this.stringDesde = this.stringDesdeInicial;
    }
    if(this.fechaHastaTemp == null){
      let actual: Date = new Date
      this.fechaHastaTemp = {year: actual.getFullYear(), month: actual.getMonth() + 1, day: actual.getDate()};
    }
    this.stringHasta = this.fechaHastaTemp.year+'-'+ this.fechaHastaTemp.month+'-'+this.fechaHastaTemp.day
    this.administradorIpService.consultarHistoricoDirecciones(this.direccionIp,
    this.stringDesde, this.stringHasta)
    .subscribe(
      respuesta => {
        this.historicos = respuesta;
        this.modalRef.close();
      },
      error =>{this.modalRef.close()}
    )
  }

  public convertirDatePickerToString(datePicker): string{
    return datePicker.year+'-'+ datePicker.month+'-'+datePicker.day
  }

  public reactivarAsignacion(historicoSeleccionado: HistoricoDireccionesDto,
    cargandoModal, alertaModal):void{
    let nuevoHistorico: HistoricoDireccionesDto = new HistoricoDireccionesDto();
    this.modalRef = this.modalService.open(cargandoModal,{backdrop: 'static', keyboard:false, size: 'lg'});
    this.indexSeleccionado = this.historicos.indexOf(historicoSeleccionado);
    if(this.historicos[this.indexSeleccionado].idAsignacion != null
    && this.historicos[this.indexSeleccionado].indicadorReactivar){
      this.administradorIpService
      .reactivarAsignacion(this.historicos[this.indexSeleccionado]).subscribe(
        resultado => {
          nuevoHistorico = resultado
          this.historicos[this.indexSeleccionado].indicadorReactivar = false;
          this.historicos.splice(0,0,nuevoHistorico);
          this.modalRef.close();
          this.mensajeAlerta = "Se ha reactivado la IP exitosamente";
          this.advertenciaPermisos = " Recuerde volver a solicitar los permisos" +
          " en Firewall interno y Firewall perimetral con el área de seguridad"
          this.modalRef = this.modalService.open(alertaModal,{backdrop: 'static', keyboard:false, size: 'lg'});
        },
        error => {
          this.modalRef.close();
        }
      )
    }
  }

  public cerrarAlertaModal(): void{
    this.modalRef.close();
    this.mensajeAlerta = "";
    this.advertenciaPermisos = "";
  }

  public async exportar(cargandoModal): Promise<void>{
    this.modalRef = this.modalService.open(cargandoModal,{backdrop: 'static', keyboard:false, size: 'lg'});
    const blob = await this.administradorIpService
      .exportarHistoricoDirecciones(this.historicos);
    const url = window.URL.createObjectURL(blob);

    const link = this.downloadLink.nativeElement;
    link.href = url;
    link.download = 'Historico.xls';
    link.click();
    window.URL.revokeObjectURL(url);
    this.modalRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/historico-asignaciones/historico-asignaciones.component.ts